import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { db } from "../../../lib/firebase";
import { useFirestoreDocOnce } from "../../../hooks/useFirestoreDocOnce";
import { GroupForm } from "./GroupForm";
import type { Audience } from "@event-planner/shared";

export function GroupEditPage() {
  const { groupId } = useParams<{ groupId: string }>();

  const docRef = useMemo(
    () => (groupId ? doc(db, "audiences", groupId) : null),
    [groupId],
  );
  const { data: group, loading } = useFirestoreDocOnce<Audience>(docRef);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!group) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="h5" component="h1">
          Group not found
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          This group may have been deleted.
        </Typography>
      </Box>
    );
  }

  return <GroupForm mode="edit" initialData={group} />;
}
